import React from "react"
import { connect } from 'react-redux'
import { withRouter } from "react-router-dom"
import dateFns from "date-fns"
import { formatDate } from "../../../utils/formatDate"

const isExpired = (membershipExpires) => !dateFns.isAfter(membershipExpires, new Date())

// sc-37887: a member can renew from the expiry day itself, as on the server
// (User#membership_renewable_by_member?).
const isRenewableByMember = (membershipExpires) =>
  !dateFns.isAfter(membershipExpires, dateFns.endOfDay(new Date()))

// The organization setting allow_profile_access_to_members lets members see
// other members' profiles without their membership details. A member still
// sees their own, or they could not renew. auth.userId is a string after a
// page reload (restored from localStorage).
// A native button (keyboard and screen reader) that looks like the text link.
const linkButtonStyle = { fontSize: "inherit", lineHeight: "inherit" }

export const showsMembershipInfo = ({ user, allowProfileAccessToMembers, currentUserId }) => {
  if (typeof user.member_type_name === "undefined") return false
  return !allowProfileAccessToMembers || String(user.id) === String(currentUserId)
}

export const MembershipInfo = function ({user, policyRes, expiryDate, renewHandler, roleLevel, currentUserId, allowProfileAccessToMembers}) {
  if (!showsMembershipInfo({ user, allowProfileAccessToMembers, currentUserId })) return null

  const isAdmin = () => {
    return ["super_admin", "site_admin", "staff"].includes(roleLevel)
  }

  const canAdminRenew = isAdmin() && policyRes.edit_this_user
  // A member renews only their own membership, and only after it expires.
  const canMemberRenew = String(user.id) === String(currentUserId) && isRenewableByMember(user.membership_expires)
  // The same decision picks the form: the admin form or the member renewal.
  const openRenewal = () => renewHandler({ memberRenewal: !canAdminRenew })

  return (
    <div className="card mt-3">
      <div className="card-body p-3">
        <div className="card-text">
          <div className="row border-bottom">
            <div className="col-12">
              <p className="font-weight-bold">
                {user.member_type_id !== null && user.member_type_name !== null
                  ? `${user.member_type_name} Member`
                  : "Non Member"}
                {user.partner_organization_name && ` / ${user.partner_organization_name}`}
              </p>
            </div>
          </div>
          {user.member_type_id &&
          <>
            {user.lifetime &&
            <div className="row border-bottom">
              <div className="col-12 d-flex justify-content-between py-3">
                    <span className="font-weight-bold">
                      No Expiration Date
                    </span>
              </div>
            </div>
            }
            {!user.lifetime && user.membership_expires !== null &&
              <div className="row border-bottom">
                <div className="col-12 d-flex justify-content-between py-3">
                  <span className="font-weight-bold">
                    {isExpired(user.membership_expires)
                      ? "Membership Expired"
                      : "Expires"}
                  </span>
                  <span>{formatDate(expiryDate, 'YYYY/MM/DD')}</span>
                  {(canAdminRenew || canMemberRenew) && (
                    <button type="button" className="btn btn-link p-0 align-baseline" style={linkButtonStyle} onClick={openRenewal}>Renew</button>
                  )}
                </div>
              </div>
            }
            {(!user.lifetime && user.membership_expires === null) &&
            <div className="row border-bottom">
              <div className="col-12 d-flex justify-content-between py-3">
                <span className="font-weight-bold">
                  No Expiration Date
                </span>
                {canAdminRenew && (
                  <button
                    type="button"
                    className="btn btn-link p-0 ml-2 align-baseline"
                    style={linkButtonStyle}
                    onClick={openRenewal}
                  >
                    Record one now
                  </button>
                )}
              </div>
            </div>
            }
          </>
          }
        </div>
        <div className="row">
          <div className="col-12 d-flex justify-content-between pt-3">
            <span className="font-weight-bold">Friend Since</span>
            <span>
              {formatDate(user.created_at, 'YYYY/MM/DD')}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return { roleLevel: state.auth.roleLevel, currentUserId: state.auth.userId }
}
export default connect(mapStateToProps)(withRouter(MembershipInfo))
